const Error = {
  ER0001: "Ngày hết hạn GPDKVT không được nhỏ hơn ngày cấp GPDKVT",
  ER0002: "Tên đơn vị không được bỏ trống",
  ER0003: "Huyện/TP không được bỏ trống",
  ER0004: "Phường/Xã không được bỏ trống",
  ER0005: "Loại hình vận tải không được bỏ trống",
  ER0006: "Số đăng ký không được bỏ trống",
  ER0007: "Loại hình phương tiện vận tải được bỏ trống",
  ER0008: "Đơn vị không được bỏ trống",
  ER0009: "Tỉnh Thành không được bỏ trống",
  ER0010: "Huyện/TP không được bỏ trống",
  ER0011: "Huyện/TP không được bỏ trống",
  ER0012: "Phường/Xã không được bỏ trống",
  ER0013: "Tên không được bỏ trống",
  ER0014: "Tên loại hình phương tiện vận tải không được bỏ trống",
  ER0015: "Phân loại vận tải không được bỏ trống",
  ER0016: "Phân loại phương tiện không được bỏ trống",
  ER0017: "Tên loại vận tải không được bỏ trống",
  ER0018: "Loại vi phạm không được bỏ trống",
  ER0019: "Cơ quan xử lý không được bỏ trống",
  ER0020: "Trạng thái xử lý không được bỏ trống",
  ER0021: "Trích yếu không được bỏ trống",
  //ER0022: "Loại vi phạm không được bỏ trống",
  ER0023: "Loại văn bản không được bỏ trống",
  ER0024: "Cơ quan ban hành không được bỏ trống",
  ER0025: "Số ký hiệu không được bỏ trống",
  ER0026: "Thời gian trả khách phải sau thời gian đón khách",
  ER0027: "Số hợp đồng không được bỏ trống",
  ER0028: "Tên đơn vị thuê không được bỏ trống",
  ER0029: "Điểm đầu không được bỏ trống",
  ER0030: "Điểm cuối không được bỏ trống",
  ER0031: "Phương tiện không được bỏ trống",
  ER0032: "Lái xe không được bỏ trống",
  ER0033: "Tỉnh (điểm đầu) không được bỏ trống",
  ER0034: "Huyện/TP (điểm đầu) không được bỏ trống",
  ER0035: "Phường/Xã (điểm đầu) không được bỏ trống",
  ER0036: "Tuyến đường không được bỏ trống",
  ER0037: "Tỉnh (điểm cuối) không được bỏ trống",
  ER0038: "Huyện/TP (điểm cuối) không được bỏ trống",
  ER0039: "Phường/Xã (điểm cuối) không được bỏ trống",
  ER0040: "Tuyến đường không được bỏ trống",
  ER0041: "Thời gian giao hàng phải sau thời gian xếp hàng",
  ER0042: "Số giấy vận tải không được bỏ trống",
  ER0043: "Tên người thuê không được bỏ trống",
  ER0044: "Số hợp đồng không được bỏ trống",
  ER0045: "Phương tiện không được bỏ trống",
  ER0046: "Lái xe không được bỏ trống",
  ER0047: "Huyện/TX/TP không được bỏ trống",
  ER0048: "Họ tên không được bỏ trống",
  ER0049: "Ngày hết hạn GKSK không được nhỏ hơn ngày cấp GKSK",
  ER0050: "Số giấy khám sức khỏe không được bỏ trống",
  ER0051: "Đơn vị cấp không được bỏ trống",
  ER0052: "Ngày kết thúc HĐLĐ không được nhỏ hơn ngày bắt đầu HĐLĐ",
  ER0053: "Số hợp đồng lao động không được bỏ trống",
  ER0054: "Loại hợp đồng lao động không được bỏ trống",
  ER0055: "Trạng thái hợp đồng lao động không được bỏ trống",
  ER0056: "Ngày hết hạn GPLX không được nhỏ hơn ngày cấp GPLX",
  ER0057: "Số giấy phép lái xe không được bỏ trống",
  ER0058: "Hạng giấy phép lái xe không được bỏ trống",
  ER0059: "CMND/CCCD không được bỏ trống",
  ER0060: "Họ tên không được bỏ trống",
  ER0061: "Số CMND/CCCD không được bỏ trống",
  ER0062: "Họ tên không được bỏ trống",
  ER0063: "Thuận lợi, khó khăn không được bỏ trống",
  ER0064: "Đề xuất, kiến nghị không được bỏ trống",
  ER0065: "Số phù hiệu không được bỏ trống",
  ER0066: "Cơ quan cấp phép không được bỏ trống",
  ER0067: "Ngày cấp phù hiệu không được bỏ trống",
  ER0068: "Màu phù hiệu không được bỏ trống",
  ER0069: "Loại phù hiệu không được bỏ trống",
  ER0070: "Trạng thái phù hiệu không được bỏ trống",
};

const Success = {
  SC0001: "Successful validation",
  SC0002: "success0002",
  SC0003: "success0003",
};

const Warning = {
  WR0001: "warning0001",
  WR0002: "warning0002",
  WR0003: "warning0003",
};

export { Error, Success, Warning };
